@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@thin-grey-border: 1px solid @settings-page--printing-setup-print--border-color;

.print-to-description {
  width: 100%;
  background-color: @settings-page--printing-setup-print-message--background-color;
  padding: 15px;
  border-bottom: 1px solid @settings-page--printing-setup-print-message--border-color;
}

.print-to-option {
  display: flex;
  flex-direction: column;
  padding: 10px;

  &:hover {
    cursor: pointer;
    background-color: @settings-page--printing-setup-print-message--hover--background-color;
  }
}

.button-title {
  display: flex;
  align-items: center;
  color: @settings-page--printing-setup-print-list-button--text-color;
}

.button-description {
  margin-top: 5px;
}

.modal-body {
  padding: 10px;
  display: flex;
  flex-direction: column;
  height: 450px;
  width: 430px;
  overflow-x: scroll;
}

.back-to-options {
  display: flex;
  align-items: center;
}

.back-icon {
  height: 15px;
  padding-right: 5px;
}

.show-hidden-checkbox {
  display: flex;
  flex-direction: row-reverse;
  border-bottom: @thin-grey-border;
  padding: 0 10px 10px;
}

.icon {
  width: 20px;
  margin: 0 10px 0 5px;
  fill: @settings-page--printing-setup-print-list--fill-color;
}

.workstation-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
}

.workstation-printers {
  padding: 10px;
  border-bottom: @thin-grey-border;
}

.workstation-name {
  color: @settings-page--printing-setup-print-list-workstation--text-color;
}

.ws-icon {
  width: 20px;
  margin-right: 5px;
  fill: @settings-page--printing-setup-print-list-workstation--icon-color;
}

.printer {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;

  &.hidden-printer {
    > .printer-name {
      color: @settings-page--printing-setup-print-list-printer--hidden--text-color;

      > .ws-icon {
        fill: @settings-page--printing-setup-print-list-printer--hidden--icon-color;
      }
    }
  }
}

.printer-name {
  color: @settings-page--printing-setup-print-list-printer-name--text-color;
  font-size: 14px;
  overflow-wrap: normal;
  max-width: 300px;

  > .ws-icon {
    width: 12px;
    fill: @settings-page--printing-setup-print-list-printer-name--fill-color;
  }

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}

.disabler {
  font-size: 14px;
  color: @settings-page--printing-setup-print-list-printer--disabled--text-color;

  > .ws-icon {
    fill: @settings-page--printing-setup-print-list-printer--disabled--icon-color;
    width: 12px;
  }
}

.install-connect-message {
  display: flex;
  flex-direction: column;
  height: 150px;
  justify-content: space-evenly;
  padding: 15px;
}
